// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","size":"125px","ingredient":"G89d1d1","imageContainer":"G2485d3","loadingSkeleton":"Gaa70a6","loading-skeleton":"Ga76db9"};